import Card from "components/card";
import { useNavigate } from "react-router-dom";
import { dateToFrench } from "utils/date";
import { getIcon } from "utils/icons";

const LastProductions = (props: { productions: any }) => {
    const { productions } = props;
    const navigate = useNavigate();
    
    return (
        <Card extra={"w-full p-4 h-full border"}>
            <div className="mb-5 w-full flex items-center justify-between">
                <div>
                    <p className="text-lg font-medium">
                        Vos dernières productions
                    </p>
                    <p className="mt-2 text-base text-gray-600">
                        Liste de vos dernières productions
                    </p>
                </div>
                <button
                    onClick={() => navigate('/production/history')}
                    className="rounded-lg bg-toola-500 px-4 py-2 text-sm font-medium text-white hover:bg-toola-600 transition-colors"
                >
                    Voir tout
                </button>
            </div>
            {productions &&
                productions.slice(0, 3).map((production: any) => (
                    <div 
                        key={production._id}
                        onClick={(e) => {
                            e.stopPropagation();
                            console.log('Navigating to /production/history');
                            navigate('/production/history');
                        }}
                        className="flex w-full items-center justify-between rounded-2xl border bg-white p-3 shadow-gray-200 mb-2 cursor-pointer hover:shadow-md hover:border-toola-500 transition-all"
                    >
                        <div className="flex items-center mb-3">
                            <div className="flex items-center justify-center">
                                <img
                                    className="h-24 w-24 rounded-xl"
                                    src={getIcon(
                                        production.productName,
                                        "product"
                                    )}
                                    alt=""
                                />
                            </div>
                            <div className="">
                                <p className="text-lg ml-2 font-medium text-navy-700 dark:text-white">
                                    {production.productName ===
                                    "Product not found"
                                        ? "Le produit n'existe plus"
                                        : production.productName}{" "}
                                    x{production.quantity}
                                </p>
                                <p className="mt-2 ml-2 text-sm text-gray-600">
                                    {production.date &&
                                        dateToFrench(production.date)}
                                    -{" "}
                                    {production.comment !== ' '
                                        ? production.comment
                                        : "Aucun commentaire"}
                                </p>
                            </div>
                        </div>
                        <div className="flex w-[130px] items-center justify-center rounded-lg bg-green-100 py-2 text-base font-bold text-green-500">
                            Terminé
                        </div>
                    </div>
                ))}
        </Card>
    );
};

export default LastProductions;
